var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/guideline-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5d57f0c8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/guideline-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/GuidelineList.vue
// module id = 611
// module chunks = 1